import { styled } from '@mui/material'

export const ErrorContainer = styled('span')({
	color: '#B92D00',
	fontSize: '10px',
	position: 'absolute',
	marginTop: 5
})